import { ListItemText, Typography, ListItem, Divider } from "@mui/material";
import SummaryLine from "./SummaryLine";

export default function SummaryList({
	title,
	data,
	color,
	isPercent,
	categoryKeys,
}) {
	const totalValue = data
		? Object.values(data).reduce((acc, val) => acc + val, 0)
		: 0;
	const userCurrency = localStorage.getItem("userCurrency");

	const getCategoryColor = (category) => {
		const categoryObj = categoryKeys.find((cat) => cat.key === category);
		return categoryObj ? categoryObj.color : "#000000";
	};

	return (
		<>
			<ListItem sx={{ pt: 0, pb: 0, color: { color } }}>
				<ListItemText>
					<Typography
						variant="h6"
						gutterBottom
						sx={{ marginBottom: 0 }}
					>
						{title}
					</Typography>
				</ListItemText>
				<ListItemText sx={{ textAlign: "right", ml: 3 }}>
					<Typography
						variant="h6"
						gutterBottom
						sx={{ marginBottom: 0, textWrap: "nowrap" }}
					>
						{`${totalValue.toFixed(2).toLocaleString()} ${userCurrency}`}
					</Typography>
				</ListItemText>
			</ListItem>
			{data &&
				Object.entries(data).map(([category, value]) => (
					<SummaryLine
						key={category}
						category={category}
						value={value}
						isPercent={isPercent}
						groupValue={totalValue}
						color={getCategoryColor(category)}
					/>
				))}
			<Divider />
		</>
	);
}
